import { render, staticRenderFns } from "./HoveredButton.vue?vue&type=template&id=0b4736f7&"
import script from "./HoveredButton.vue?vue&type=script&lang=js&"
export * from "./HoveredButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports